define((require) => {
    "use strict";

    var Marionette = require("marionette"),
        Icons      = require("shared/ui/assets/Icons"),
        template   = require("ui/share/ShareRecipientView.tpl");

    /**
     * Item view for a share recipient.
     *
     * @author Bruce Mackenzie Nielsen
     * @class ShareRecipientView
     * @constructor
     */
    return Marionette.ItemView.extend({
        template: template,
        className: "choose-recipients-list-item-wrapper",

        ui: {
            removeButton: ".choose-recipients-list-item-remove-button"
        },

        bindings: {
            ".choose-recipients-list-item": "displayName"
        },

        modelEvents: {
            "change:selected": "_updateSelectedState"
        },

        events: {
            "click": function() {
                this.model.set("selected", !this.model.get("selected"));
            }
        },

        _updateSelectedState: function() {
            if (this.model.get("selected")) {
                this.$el.addClass("selected");
            } else {
                this.$el.removeClass("selected");
            }
        },

        onRender: function() {
            this.ui.removeButton.append(Icons.X_BUTTON.createElement());

            this._updateSelectedState();
            this.stickit();
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/share/ShareRecipientView.js